module.exports = __webpack_public_path__ + "8101804d53b056e4d7cd3c1be91c101d.png";